module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Change Method',
        standard: 'Standard',
        sameDayDelivery: 'Same-Day Delivery',
        bopis: 'Buy Online & Pick Up',
        autoReplenish: 'Auto-Replenish',
        autoReplenishEnroll: 'Please enroll from the product page.',
        autoReplenishDisclaim: 'If you switch to another fulfillment method and you would like Auto-Replenish again please enroll from the product details page.',
        checkAvailability: 'Check availability',
        confirm: 'Confirm',
        cancel: 'Cancel',
        bopisUnavailable: 'Buy Online & Pick Up is temporarily unavailable.',
        sameDayUnavailable: 'Same-Day Delivery is temporarily unavailable.'
    };

    return resources[label];
};
